webpackJsonp([68244379756336],{

/***/ 1043:
/***/ (function(module, exports) {

	module.exports = [{"title":"1.0.1","changelog":"https://github.com/binstd/bytom"}]

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _Container = __webpack_require__(8);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Header = __webpack_require__(36);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _TitleAndMetaTags = __webpack_require__(21);
	
	var _TitleAndMetaTags2 = _interopRequireDefault(_TitleAndMetaTags);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(4);
	
	var _versions = __webpack_require__(1043);
	
	var _versions2 = _interopRequireDefault(_versions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * @emails react-core
	 * 
	 */
	
	var Versions = function Versions() {
	  return Glamor.createElement(
	    _Container2.default,
	    null,
	    Glamor.createElement(
	      'div',
	      { css: _theme.sharedStyles.articleLayout.container },
	      Glamor.createElement(
	        'div',
	        { css: _theme.sharedStyles.articleLayout.content },
	        Glamor.createElement(
	          _Header2.default,
	          null,
	          'IPFS Versions'
	        ),
	        Glamor.createElement(_TitleAndMetaTags2.default, { title: 'Bytom - Versions' }),
	        Glamor.createElement(
	          'div',
	          { css: _theme.sharedStyles.markdown },
	          Glamor.createElement(
	            'p',
	            null,
	            'A complete release history for IPFS is available',
	            ' ',
	            Glamor.createElement(
	              'a',
	              {
	                href: 'https://github.com/binstd/IPFS',
	                target: '_blank',
	                rel: 'noopener' },
	              'on GitHub'
	            ),
	            '.',
	            Glamor.createElement('br', null),
	            'Documentation for recent releases can also be found below:'
	          ),
	          _versions2.default.map(function (version) {
	            return Glamor.createElement(
	              'div',
	              { key: version.title },
	              Glamor.createElement(
	                'h3',
	                null,
	                version.title
	              ),
	              Glamor.createElement(
	                'ul',
	                null,
	                Glamor.createElement(
	                  'li',
	                  null,
	                  Glamor.createElement(
	                    'a',
	                    { href: version.changelog, target: '_blank', rel: 'noopener' },
	                    'Changelog'
	                  )
	                ),
	                version.path && Glamor.createElement(
	                  'li',
	                  null,
	                  Glamor.createElement(
	                    'a',
	                    { href: version.path, rel: 'nofollow' },
	                    'Documentation'
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	// $FlowFixMe This is a valid path
	exports.default = Versions;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-versions-js-11139de12cff63d49384.js